import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AdminProvider from './Context/AdminContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';
import UserProvider from './Context/UserContext';
import BlockchainProvider from './Context/BlockchainContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<AdminProvider>
		<UserProvider>

		<BlockchainProvider>
			<BrowserRouter>
				<App />
			</BrowserRouter>
			</BlockchainProvider>
			</UserProvider>

		</AdminProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
